import { render, staticRenderFns } from "./GlasgowOutcomeGrading.vue?vue&type=template&id=4f115a35&scoped=true"
import script from "./GlasgowOutcomeGrading.vue?vue&type=script&lang=js"
export * from "./GlasgowOutcomeGrading.vue?vue&type=script&lang=js"
import style0 from "./GlasgowOutcomeGrading.vue?vue&type=style&index=0&id=4f115a35&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f115a35",
  null
  
)

export default component.exports